<template>
  <!-- 首页第二块 -->
  <div class="mcont2">
    <div class="mc2-left"></div>
    <div class="mc2-rig">
      <!-- <div class="mc2-rig-hea"></div> -->
      <!-- 产品卖点 -->
      <div class="mcont-title">
      {{ mcontTitle }}
      </div>
      
      <ul>
        <li>
          <h2>{{ firstTitle }}</h2>
          <p>IT Solutions business</p>
          <h3>{{ firstContent }}</h3>
          <!-- <p>Including system consulting, system planning, development, maintenance, etc </p> -->
          <!-- <p>nd we make sure each and every bean is Arabica.</p> -->
        </li>
        <li>
          <h2>{{ secondTitle }}</h2>
          <p>SES service</p>
          <h3>{{ secondContent }}</h3>
          <!-- <p>Systems, Engineers, Maintenance</p> -->
          <!-- <p>WBC champions, hailing from Italy, Japan, and China.
          </p> -->
        </li>
        <li>
          <h2>{{ thirdTitle }}</h2>
          <p>BPO business</p>
          <h3>{{ thirdContent }}</h3>
          <!-- <p>Data entry service</p> -->
        </li>
        <li>
          <h2>{{ fourthTitle }}</h2>
          <p>Information system support business of Chinese cooperative enterprises</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  computed: {
    mcontTitle() {
      return this.$store.getters.currentLang === 'zh' ? '开发强项' : '我々の強み'
    },
    firstTitle() {
      return this.$store.getters.currentLang === 'zh' ? 'IT解决方案业务' : 'ITソリューション事業'
    },
    secondTitle() {
      return this.$store.getters.currentLang === 'zh' ? 'SES业务' : 'SESビジネス'
    },
    thirdTitle() {
      return this.$store.getters.currentLang === 'zh' ? 'BPO业务' : 'BPO事業'
    },
    fourthTitle() {
      return this.$store.getters.currentLang === 'zh' ? '中国合作企业的信息系统的支援业务' : '中国の協力企業の情報システムの支援業務 '
    },
    firstContent() {
      return this.$store.getters.currentLang === 'zh' ? '我们提供全方位的IT解决方案，包括系统咨询、系统规划、开发和维护等服务 我们的专业团队将根据客户的需求提供定制化的解决方案，实现业务目标' : 'システムコンサルティング、システム企画、開発、メンテナンスなど、あらゆるITソリューションを提供しています 私たちの専門チームは、お客様のニーズに合わせたカスタマイズされたソリューションを提供し、業務目標を達成します'
    },
    secondContent() {
      return this.$store.getters.currentLang === 'zh' ? '我们拥有经验丰富的工程师团队，专注于系统的维护和管理 无论是硬件设备还是软件系统，我们都能提供高效可靠的维护服务，确保系统的稳定运行' : '我々は経験豊富なエンジニアチームを擁し、システムの維持管理に専念しています ハードウェア設備であれ、ソフトウェアシステムであれ、我々は効率的で信頼性の高いメンテナンスサービスを提供し、システムの安定した運行を確保できます'
    },
    thirdContent() {
      return this.$store.getters.currentLang === 'zh' ? '我们提供数据录入服务，帮助客户处理大量数据，并确保数据的准确性和安全性 我们拥有先进的数据录入技术和严格的数据保护措施，为客户提供高质量的服务' : 'データ入力サービスを提供し、お客様の大量のデータ処理を支援し、データの正確性と安全性を確保します 高度なデータ入力技術と厳格なデータ保護対策を持っており、お客様に高品質のサービスを提供しております'
    },
    fourthContent() {
      return this.$store.getters.currentLang === 'zh' ? '' : ''
    },
  }
}
</script>

<style scoped lang="scss">
// .aaa{
//    background: url(../../assets/images/index/bg2.jpg) no-repeat;
// }
// 内容模块二
.mcont2 {
  width: 100%;
  height: 640px;
  display: flex;

  // background: url(../../assets/images/new/room1.png) no-repeat;
  // background-position: 58%;
  >.mc2-left {
    // width: 50%;
    flex: 1;
    background: url(../../assets/images/new/room1.png) no-repeat;
    background-position: 58%;
    background-size: cover;
  }
  >.mc2-rig {
    background-color: #000;
    // margin-left: 53%;
    position: relative;
    width: 600px;
    height: inherit;

    .mcont-title {
      margin-top: 8px;
      width: 100%;
      text-align: center;
      color: #FFFFFF;
      font-size: 36px;
    }
    &::before {
      content: "";
      display: table;
    }

    // 产品卖点
    >.mc2-rig-hea {
      position: relative;
      margin-top: 50px;
      width: 130px;
      height: 76px;
      background: red;
      // background: url(../../assets/images/sprite@2x.png) no-repeat;
      background-position: 17px -133px;
      background-size: 270px;

      &::after {
        content: "";
        display: block;
        width: 36px;
        height: 2px;
        background: #a38d71;
        position: absolute;
        left: 20px;
        bottom: -30px;
      }
    }

    >ul {
      margin-top: 46px;
      margin-left: 20px;
      width: 470px;
      height: auto;

      >li {
        padding-left: 30px;
        margin-bottom: 20px;
        width: 450px;
        height: 130px;
        color: $write;

        :first-child {
          margin-top: -24px;
          font-weight: 500;
        }

        >h3 {
          // margin-top: 4px;
          font-weight: 300;
        }

        >p {
          color: #bbbbbb;
        }

        &:first-child {
          &::before {
            content: "";
            display: block;
            margin-left: -30px;
            width: 8px;
            height: 8px;
            background-color: pink;
            border-radius: 50%;
            background-color: #bbbbbb;
            // background: url(../../assets/images/sprite@2x.png) no-repeat;
            // background-size: 270px;
            // background-position: -200px -200px;
          }
        }

        &:nth-child(2) {
          &::before {
            content: "";
            display: block;
            margin-left: -30px;
            width: 8px;
            height: 8px;
            background-color: pink;
            border-radius: 50%;
            background-color: #bbbbbb;
            // background: url(../../assets/images/sprite@2x.png) no-repeat;
            // background-size: 270px;
            // background-position: -200px -200px;
          }
        }

        &:nth-child(3) {
          &::before {
            content: "";
            display: block;
            margin-left: -30px;
            width: 8px;
            height: 8px;
            background-color: pink;
            border-radius: 50%;
            background-color: #bbbbbb;
            // background: url(../../assets/images/sprite@2x.png) no-repeat;
            background-size: 270px;
            background-position: -200px -200px;
          }
        }

        &:last-child {
          &::before {
            content: "";
            display: block;
            margin-left: -30px;
            width: 8px;
            height: 8px;
            background-color: pink;
            border-radius: 50%;
            background-color: #bbbbbb;
            // background: url(../../assets/images/sprite@2x.png) no-repeat;
            background-size: 270px;
            background-position: -200px -200px;
          }
        }

        // &:nth-child(2) {
        //   &::before {
        //     content: "";
        //     display: block;
        //     margin-left: -70px;
        //     width: 36px;
        //     height: 36px;
        //     background: url(../../assets/images/sprite@2x.png) no-repeat;
        //     background-size: 270px;
        //     background-position: -160px -200px;
        //   }
        // }
        // &:last-child {
        //   &::before {
        //     content: "";
        //     display: block;
        //     margin-left: -70px;
        //     width: 36px;
        //     height: 36px;
        //     background: url(../../assets/images/sprite@2x.png) no-repeat;
        //     background-size: 270px;
        //     background-position: -120px -200px;
        //   }
        // }
      }
    }
  }
}</style>


